import React from "react";
import "../css/featured.css";
import YouMayLike from "./YouMayLike";
import Navbar from "../Navbar";
import ScrollToTop from "../ScrollToTop";

export const Featured = () => {
  return (
    <>
      <Navbar />
      <div className="featured-con">
        <div className="layout">
          <h1 className="article-title">
            Weaving Tradition into Modern Living
          </h1>
          <div className="article-category">
            Most Influential Leaders to Watch in 2025
          </div>
          <div className="share-container">
            <div className="share-buttons">
              <button className="share-button linkedin">LinkedIn</button>
              <button className="share-button twitter">Twitter</button>
              <button className="share-button facebook">Facebook</button>
            </div>
          </div>
          <div className="article-image-container">
            <img
              src="./images/Oliver-Johnson.jpg"
              alt="Professional woman at desk"
              className="article-image"
            />
            <div className="article-image-caption">
              Oliver Johnson | Founder, LoomCraft Heritage
            </div>
          </div>
          {/* Article Content */}
          <div className="article-content">
            <p>
            By Oliver Johnson
            Founder, LoomCraft Heritage When I started LoomCraft Heritage, I wasn’t just launching a
              company—I was reviving a legacy. Growing up in a family steeped in
              handloom traditions, I saw firsthand the artistry and
              craftsmanship that went into every thread. Yet, as the world
              shifted toward mass production, I also witnessed the struggles of
              artisans trying to preserve their craft in a rapidly changing
              economy. LoomCraft Heritage was born out of a desire to bridge
              this gap—blending timeless handloom traditions with modern design
              sensibilities to create products that are as meaningful as they
              are beautiful. <br /> <h4> A Legacy of Craftsmanship</h4>  At LoomCraft Heritage, we
              specialize in handcrafted textiles that celebrate the art of
              weaving. From intricately designed throws to elegant handwoven
              apparel, every piece is a testament to the skill and dedication of
              our artisans. But for us, it’s about more than just creating
              beautiful products. It’s about telling a story—of tradition,
              culture, and the human touch. Each item we produce carries the
              legacy of generations of weavers who have poured their hearts into
              perfecting their craft. <br /> <h4> The Art of Sustainable Luxury </h4> In today’s
              fast-paced, disposable fashion world, we stand for something
              different: sustainable luxury. We believe that luxury isn’t about
              excess—it’s about quality, authenticity, and responsibility.
              That’s why sustainability is at the core of everything we do. We
              source natural, eco-friendly fibers, use dyes that are kind to the
              environment, and ensure every process minimizes waste. By
              supporting LoomCraft Heritage, our customers are not just
              purchasing a product—they’re investing in a more thoughtful,
              sustainable future. <br /> <h4> Supporting Artisans, Empowering Communities </h4>
              One of my proudest achievements as a founder is the impact
              LoomCraft Heritage has had on artisan communities. Many of the
              weavers we work with come from rural areas where opportunities are
              limited. By providing fair wages, access to global markets, and
              skill development programs, we’re helping to create sustainable
              livelihoods and preserve their craft for generations to come.
              These relationships are the backbone of our business. They remind
              us that our success is not just measured in profits but in the
              lives we touch and the traditions we keep alive. <br /> <h4> Challenges and
              Growth </h4> Like any entrepreneur, I’ve faced my share of challenges.
              Introducing handloom products to a market dominated by fast
              fashion required educating consumers about the value of
              craftsmanship and sustainability. But every challenge brought new
              opportunities for growth. By embracing digital platforms, we’ve
              expanded our reach, connecting with customers who value quality
              and authenticity. Our journey has been a blend of tradition and
              innovation—just like our products. <br /> <h4>A Vision for the Future</h4>  Looking
              ahead, my vision for LoomCraft Heritage is to continue weaving a
              global tapestry of artistry and sustainability. We’re exploring
              collaborations with designers, expanding into home décor, and
              investing in technologies that enhance traditional processes
              without compromising their essence. But no matter how much we
              grow, our mission remains the same: to honor the art of handloom
              weaving and share its beauty with the world. <br /> <h4> A Call to Fellow
              Leaders </h4> To my fellow entrepreneurs and leaders: let’s remember the
              importance of purpose in business. Whether you’re in textiles,
              tech, or any other industry, success isn’t just about what you
              build—it’s about how you build it and who you uplift along the
              way. At LoomCraft Heritage, we’re always looking to connect with
              others who share our values of sustainability, craftsmanship, and
              community empowerment. If you’re passionate about making a
              difference, let’s collaborate and create something extraordinary
              together. Here’s to weaving a brighter, more sustainable
              future—one thread at a time.
            </p>
          </div>
        </div>
        <div className="popular">
          <div className="sub-articles">
            <div className="sub-article">
              <img src="../images/sr3.png" alt="Cloud Computing" />
              <p>
                The Next Level Cloud Computiud Computing Treud Computing Trend
                Computind Computing Trends in 2025
              </p>
            </div>
            <div className="sub-article">
              <img src="./images/sr3.png" alt="Healthcare" />
              <p>
                The Next Level Cloud Computiud Computing Treud Computing Trend
                Computind Computing Trends in 2025
              </p>
            </div>
            <div className="sub-article">
              <img src="./images/sr3.png" alt="Myths Busted" />
              <p>
                The Next Level Cloud Computiud Computing Treud Computing Trend
                Computind Computing Trends in 2025
              </p>
            </div>
            <div className="sub-article">
              <img src="./images/sr3.png" alt="Cloud Computing" />
              <p>
                The Next Level Cloud Computiud Computing Treud Computing Trend
              </p>
            </div>
            <div className="sub-article">
              <img src="./images/sr3.png" alt="Healthcare" />
              <p>
                The Next Level Cloud Computiud Computing Treud Computing Trend
                Computind Computing Trends in 2025
              </p>
            </div>
          </div>
        </div>
      </div>
      <ScrollToTop />
      <YouMayLike />
    </>
  );
};
